export default "__VITE_ASSET__MjwFrUda__"